import { createSlice } from "@reduxjs/toolkit";
import {
  cancelOrder,
  generateOrderInvoice,
  getAllOrders,
  getOrderDetails,
} from "store/actions/orderSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 100,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  orders: [],
  orderDetails: {},
  filterState: {
    currentPage: 1,
    keyword: "",
    dates: [],
    selectedFilters: {
      status: -1,
      orderBy: -1,
      spaceTypeInt: -1,
      branches: [],
    },
  },
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    updateFilterState: (state, action) => {
      state.filterState = {
        ...state.filterState,
        ...action.payload,
      };
    },
    resetFilterState: (state) => {
      state.filterState = initialState.filterState;
    },
    setSortedOrders: (state, action) => {
      state.orders = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};
          state.orders = data;

          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getOrderDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrderDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.orderDetails = data;
        }
      })
      .addCase(getOrderDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(cancelOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(generateOrderInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(generateOrderInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(generateOrderInvoice.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default orderSlice.reducer;

export const { updateFilterState, resetFilterState, setSortedOrders  } = orderSlice.actions;
